<template>
  <v-data-table
    :headers="headers"
    :items="warranties"
    sort-by="model"
    class="elevation-1"
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="accent"
      >
        <v-toolbar-title class="white--text">Warranty</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <v-card>
            <v-card-title class="primary">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select
                        v-model="editedItem.type"
                        :items="types"
                        item-text="label"
                        item-value="value"
                        label="Warranty Type"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.duration"
                      label="Duration"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="editedItem.start_date"
                            label="Start Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="editedItem.start_date"
                        @input="menu = false"
                        ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="editedItem.end_date"
                            label="End Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="editedItem.end_date"
                        @input="menu = false"
                        ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select
                        v-model="editedItem.status"
                        :items="statuses"
                        item-text="label"
                        item-value="value"
                        label="Status"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-textarea
                      v-model="editedItem.comment"
                      label="Comment"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="grey lighten-3">
              <v-btn
                large min-width="49%" color="blue darken-1" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="title justify-center">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip
        color="primary"
        text-color="white"
        v-if="item.status == 'pending'"
      >
        Pending
      </v-chip>
      <v-chip
        color="orange"
        text-color="white"
        v-else-if="item.status == 'in_progress'"
      >
        In Progress
      </v-chip>
      <v-chip
        color="red"
        text-color="white"
        v-else-if="item.status == 'expired'"
      >
        Expired
      </v-chip>
    </template>
  </v-data-table>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            headers: [
                {
                  text: 'Warranty Type',
                  align: 'start',
                  sortable: false,
                  value: 'type',
                },
                { text: 'Duration', value: 'duration', sortable: false },
                { text: 'Start Date', value: 'start_date', sortable: false },
                { text: 'End Date', value: 'end_date', sortable: false },
                { text: 'Status', value: 'status', sortable: false },
            ],
            warranties: [],
            editedIndex: -1,
            editedItem: {
                type: '',
                duration: '',
                start_date: new Date().toISOString().substr(0, 10),
                end_date: new Date().toISOString().substr(0, 10),
                status: 'pending',
                comment: ''
            },
            defaultItem: {
                type: '',
                duration: '',
                start_date: new Date().toISOString().substr(0, 10),
                end_date: new Date().toISOString().substr(0, 10),
                status: 'pending',
                comment: ''
            },
            types: [
              { label: 'Quartz', value: 'quartz' },
              { label: 'Standard Pool', value: 'standard_pool' },
              { label: 'Vynil Liner Full', value: 'vynil_liner_full' },
              { label: 'Vynil Liner Limited', value: 'vynil_liner_limited' },
            ],
            statuses: [
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pending', value: 'pending' },
                { label: 'Expired', value: 'expired' },
            ]
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Warranty' : 'Edit Warranty'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.initialize()
        },

        methods: {
            initialize () {
                this.warranties = [
                    {
                      type: 'Vynil Liner Full',
                      duration: '12',
                      start_date: new Date().toISOString().substr(0, 10),
                      end_date: new Date().toISOString().substr(0, 10),
                      status: 'pending',
                      comment: 'Test'
                    },
                ]
            },

            editItem (item) {
                this.editedIndex = this.warranties.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.warranties.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.warranties.splice(this.editedIndex, 1)
                this.closeDelete()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            save () {
                if (this.editedIndex > -1) {
                Object.assign(this.warranties[this.editedIndex], this.editedItem)
                } else {
                this.warranties.push(this.editedItem)
                }
                this.close()
            },
        },
    }
</script>